import image1 from "@data/images/icons/estrella.png"
import image2 from "@data/images/icons/dedo.png"
import image3 from "@data/images/icons/cabeza.png"

export const sectionIcons = [
  {
    id: 1,
    imageSrc: image1,
    title: "Somos los únicos en entregar garantías.",
  },
  {
    id: 2,
    imageSrc: image2,
    title: "Todos nuestros desarrollos son a la medida de nuestros clientes.",
  },
  {
    id: 3,
    imageSrc: image3,
    title: "Contamos con ingenieros de procesos especializados.",
  },
]
